import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    {
      id: 1,
      name: i18n.t('tipos.condicion.igual')
    },
    {
      id: 2,
      name: i18n.t('tipos.condicion.distinto')
    },
    {
      id: 3,
      name: i18n.t('tipos.condicion.contiene')
    },
    {
      id: 4,
      name: i18n.t('tipos.condicion.no_contiene')
    },
    {
      id: 5,
      name: i18n.t('tipos.condicion.comienza')
    },
    {
      id: 6,
      name: i18n.t('tipos.condicion.no_comienza')
    },
    {
      id: 7,
      name: i18n.t('tipos.condicion.termina')
    },
    {
      id: 8,
      name: i18n.t('tipos.condicion.no_termina')
    },
    {
      id: 9,
      name: i18n.t('tipos.condicion.cumple_expresion')
    },
    {
      id: 10,
      name: i18n.t('tipos.condicion.no_cumple_expresion')
    },
    {
      id: 11,
      name: i18n.t('tipos.condicion.mayor')
    },
    {
      id: 12,
      name: i18n.t('tipos.condicion.menor')
    },
    
  ]
}

export function TIPOS_CONDICION (state) {
  return configHelper.getConfig(state, 'TIPOS_CONDICION', GenerateConfig)
}
